import $ from 'jquery';

const CLASSES = {
    active: 'active'
};

class Accordion {
    constructor(el) {
        this.el = el;
        this.el.on('click', '.accordion__item__title', function() {
            $(this).parent('.accordion__item').toggleClass(CLASSES.active);
        });
    }
}

export default Accordion;